module.exports = __webpack_public_path__ + "media/images/pc/top/icon-visit-2aa2173c3a116c5db1f109397312797b.svg";